var _dec, _class;

import { registerDecorator, ValidatorConstraint } from 'class-validator';
var urlSafeRegex = /^[a-zA-Z0-9_-]*$/;
var IsUrlSafeConstraint = (_dec = ValidatorConstraint(), _dec(_class = class IsUrlSafeConstraint {
  validate(value) {
    return typeof value === 'string' && urlSafeRegex.test(value);
  }

}) || _class);
export function IsUrlSafe(validationOptions) {
  return function (object, propertyName) {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsUrlSafeConstraint
    });
  };
}